export default "__VITE_ASSET__78a9aef3__"